// extracted by mini-css-extract-plugin
export default {"ligModalContainer":"style_ligModalContainer__HMMny"};